import PaginationData from "@/models/general/PaginationData";
import EmployeeBranch from "./EmployeeBranch";
import EmployeeBranchesFilter from "./EmployeeBranchesFilter";

export default class EmployeeBranches {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.employeeBranchesData = [];
    this.employeeBranch = new EmployeeBranch();
    this.filterData = new EmployeeBranchesFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.employeeBranchesPagination);
    this.employeeBranchesData =
      data.employeeBranchesPagination.employeeBranchesData;
  }
}
